import { getClient } from "./client";
import { logout } from "./logout";

export async function getToken() {
  let token = localStorage.getItem("token");
  if (token !== null) return token;
  // if (window.Cypress) {
  //   const auth0 = JSON.parse(localStorage.getItem("auth0Cypress"));
  //   return auth0.body.access_token;
  // } else {
  try {
    const client = await getClient();
    token = await client.getTokenSilently();
    if (token !== null) {
      localStorage.setItem("token", token);
    }
  } catch (error) {
    logout({
      returnTo: window.location.origin + "/login",
    });
    return "Login Issue";
  }
  // }
  return token;
}